<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="edit">
        <span v-if="isNewOrder"> Create Standing Order </span>
        <span v-else> Editing Standing Order</span>
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>
    <v-col cols="12">
      <StandingProgress :step="stepProgress"></StandingProgress>
    </v-col>
    <v-col cols="12" lg="8" sm="12">
      <v-form ref="standingCreateForm" @submit.prevent="submit">
        <Date
          v-model="orderDate"
          :standing="1"
          :order="currentStandingOrderTrolly"
        >
        </Date>
        <v-text-field
          v-model="standingName"
          :rules="nameRules"
          type="text"
          label="Standing Order Name"
          @focus="$event.target.select()"
          outlined
          persistent-hint
          hint="Name to identify Standing Order"
          maxlength="40"
          counter
          :disabled="!isNewOrder"
          color="blue darken-2"
        ></v-text-field>

        <v-col cols="12" v-show="orderDate">
          <v-banner icon="date_range">Select Days of the Week</v-banner>

          <v-row justify="start" align="start" no-gutters>
            <v-btn-toggle v-model="toggle_days" multiple v-show="orderDate">
              <v-col class="pa-0">
                <v-btn
                  v-for="dayItems in days"
                  :key="dayItems.text"
                  text
                  active-class="primary"
                  class="mr-1 mb-1"
                  :value="dayItems.value"
                  :disabled="checkDisabled(dayItems.value)"
                >
                  {{ dayItems.text }}
                </v-btn>
              </v-col>
            </v-btn-toggle>
          </v-row>
        </v-col>

        <v-btn
          :loading="loading"
          block
          color="blue darken-2"
          outlined
          x-large
          type="submit"
          class="mt-4"
          :disabled="!orderDate || !standingName || toggle_days.length == 0"
        >
          <span v-if="isNewOrder">Confirm</span>
          <span v-else> Update </span>
        </v-btn>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import StandingProgress from "@/components/order/standing/StandingProgress.vue";
import Date from "@/components/order/Date.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  name: "StandingOrderCreate",
  components: { StandingProgress, Date },

  data: () => {
    return {
      stepProgress: 1,
      orderDate: null,
      standingName: "",
      isNewOrder: true,
      toggle_days: [],
      days: [
        { text: "Mon", value: "monday" },
        { text: "Tue", value: "tuesday" },
        { text: "Wed", value: "wednesday" },
        { text: "Thu", value: "thursday" },
        { text: "Fri", value: "friday" },
        { text: "Sat", value: "saturday" },
        { text: "Sun", value: "sunday" },
      ],
      nameRules: [(v) => !!v || "Name Required"],
      loading: false,
    };
  },

  watch: {
    orderDate: function (val) {
      let fullDay = this.dayOnOrderDate(val);

      if (!this.toggle_days.includes(fullDay)) {
        this.toggle_days.push(fullDay);
      }
    },
  },

  computed: {
    ...mapState(["selectedStandingOrder"]),
    ...mapState({
      selectedSO: (state) => state.standingOrders.selectedStandingOrder,
    }),

    selectedDays() {
      let daysChosen = {};
      this.days.forEach((day) => {
        if (this.toggle_days.includes(day.value)) {
          daysChosen[day.value] = 1;
        } else {
          daysChosen[day.value] = 0;
        }
      });
      return daysChosen;
    },

    customerAvailableDays() {
      // if (this.$store.getters.retrieveCustomerDeilveryDays) {
      //     return this.$store.getters.retrieveCustomerDeilveryDays
      // }
      if (this.$store.getters.retrieveCustomerAvailableDays) {
        return this.$store.getters.retrieveCustomerAvailableDays;
      }
      return false;
    },

    currentStandingOrderTrolly() {
      if (!this.isNewOrder && this.$store.getters.retrieveStandingOrderTrolly) {
        return this.$store.getters.retrieveStandingOrderTrolly;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      "createNewStandingOrderTrolly",
      "updateSODays",
      "createNewStandingOrder",
      "getStandingOrders",
      "clearSelectedStandingOrder",
      "setSelectedStandingOrder",
      "updateStandingTrollyOrderDate",
      "setSnackbar",
    ]),

    dayOnOrderDate(givenDate) {
      if (givenDate) {
        let fullDate = moment(givenDate).format("dddd, Do MMMM YYYY");
        return fullDate.split(",")[0].toLowerCase();
      }
      return false;
    },

    async submit() {
      console.log("-- Standing Form");
      console.log(this.standingName);
      console.log(this.$refs.standingCreateForm);
      this.loading = true;

      if (this.$refs.standingCreateForm.validate()) {
        this.savingForm = true;

        let orderObject = {
          name: this.standingName,
          orderDate: this.orderDate,
        };

        if (this.isNewOrder) {
          await this.newStandingOrder(orderObject);
        } else {
          await this.updateStandingOrder(orderObject.orderDate);
        }
      }
    },

    checkDisabled(day) {
      // let formatedDay = day.charAt(0).toUpperCase() + day.slice(1)
      // let formatString = "deliveryDay"+formatedDay
      if (this.customerAvailableDays) {
        if (this.customerAvailableDays[day] == 1) {
          return false;
        }
        return true;
      }
    },

    async updateStandingOrder(orderInfo) {
      //UPDATE TROLLY HEADER
      let response = await this.updateStandingTrollyOrderDate(orderInfo);
      console.log("update trolly header response");
      console.log(response);

      if (response) {
        //UPDATE SO DAYS ROW
        let soObj = {
          chosenDays: this.selectedDays,
        };
        let soResponse = await this.updateSODays(soObj);

        if (soResponse == true) {
          // CALL GET TROLLIES
          let allStandingOrders = await this.getStandingOrders();
          //filter standing order with response
          let filteredSO = allStandingOrders.filter((order) => {
            return order.id == this.selectedSO.id;
          });
          console.log("Filtered..", filteredSO);
          //set clear standingOrders
          this.clearSelectedStandingOrder();
          //set selected standing order..
          this.setSelectedStandingOrder(filteredSO[0]);

          this.setSnackbar({ text: "Standing Order Updated" });
          this.loading = false;
          this.$router.push({ name: "StandingOrderProducts" });
        } else {
          console.log("Error updating standing order row");
          this.setSnackbar({
            color: "error",
            text: "Error updating standing order",
          });
          this.loading = false;
        }
      } else {
        console.log("Trolly header update error");
        this.setSnackbar({
          color: "error",
          text: "Error updating standing order trolly",
        });
        this.loading = false;
      }
    },

    async newStandingOrder(orderObject) {
      let response = await this.createNewStandingOrderTrolly(orderObject);
      console.log("-- Standing Order Trolly Create Reponse");
      console.log(response);
      if (response.success) {
        // this.$router.push({name:'StandingOrderDays'})
        let standingOrderObj = {
          trollyId: response.trollyId,
          chosenDays: this.selectedDays,
        };
        let standingOrderResponse = await this.createNewStandingOrder(
          standingOrderObj
        );
        console.log(standingOrderResponse);
        if (standingOrderResponse) {
          //get Standing orders
          let allStandingOrders = await this.getStandingOrders();
          //filter standing order with response
          let filteredSO = allStandingOrders.filter((order) => {
            return order.id == standingOrderResponse.so_id;
          });
          console.log("Filtered..", filteredSO);
          //set clear standingOrders
          this.clearSelectedStandingOrder();
          //set selected standing order..
          this.setSelectedStandingOrder(filteredSO[0]);
          this.loading = false;
          //then redirect..
          this.$router.push({ name: "StandingOrderProducts" });
        }
      } else {
        console.log("failed to create standing order");
        this.loading = false;
      }
    },
  },

  activated() {
    if (this.$route.params.newCreate) {
      console.log("creating-new-standing");
      this.standingName = "";
      this.orderDate = null;
      (this.isNewOrder = true), (this.toggle_days = []);
    } else {
      this.isNewOrder = false;
      this.orderDate = this.currentStandingOrderTrolly.order_date;
      this.standingName = this.currentStandingOrderTrolly.name;
      this.toggle_days = this.$store.getters.retrieveStandingOrderRepeatDays;
    }
  },
};
</script>